import produce from 'immer';

const derivedProps = {};

export const registerDerivedProp = (...rest) => {
  if (rest.length > 2) {
    const cb = rest[rest.length - 2];
    const propName = rest[rest.length - 1];
    for (let i = 0, l = rest.length - 2; i < l; ++i) {
      if (!derivedProps[rest[i]]) {
        derivedProps[rest[i]] = [];
      }
      derivedProps[rest[i]].push({
        cb,
        props: rest.slice(0, rest.length - 2),
        propName,
      });
    }
  }
};

export const calculateDerivedProps = (updatedData, state) => {
  let newData = updatedData;
  const calculatedCBs = [];
  if (updatedData) {
    Object.keys(updatedData).forEach((key) => {
      if (derivedProps[key]) {
        derivedProps[key].forEach((cbObject) => {
          if (!calculatedCBs.includes(cbObject)) {
            calculatedCBs.push(cbObject);
            const params = cbObject.props.map((paramName) =>
              paramName in updatedData
                ? updatedData[paramName]
                : state[paramName]
            );
            newData = produce(newData, (draft) => {
              draft[cbObject.propName] = cbObject.cb.apply(undefined, params);
            });
          }
        });
      }
    });
  }
  return newData;
};
